import React from "react";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/skyline_high_2005_prom.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/skyline_high_2005_prom.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/skyline_high_2005_prom.png-wvc-sizes",
  alt: "Skyline High Class of 2005 Prom Night"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/varsity_football_champions.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/varsity_football_champions.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/varsity_football_champions.png-wvc-sizes",
  alt: "Varsity Football Championship Celebration"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/graduation_day_caps.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/graduation_day_caps.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/graduation_day_caps.png-wvc-sizes",
  alt: "Graduation Day Cap Toss 2005"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/drama_club_performance.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/drama_club_performance.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/drama_club_performance.png-wvc-sizes",
  alt: "Spring Musical Performance in the Auditorium"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/cafeteria_lunch_hangout.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/cafeteria_lunch_hangout.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/cafeteria_lunch_hangout.png-wvc-sizes",
  alt: "Friends hanging out in the Skyline High cafeteria"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/science_fair_winners.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/science_fair_winners.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/science_fair_winners.png-wvc-sizes",
  alt: "Science Fair First Place Winners"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/pep_rally_spirit.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/pep_rally_spirit.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/pep_rally_spirit.png-wvc-sizes",
  alt: "School Spirit at the Homecoming Pep Rally"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/yearbook_staff_meeting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/yearbook_staff_meeting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/yearbook_staff_meeting.png-wvc-sizes",
  alt: "The 2005 Yearbook Staff hard at work"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/senior_trip_bus.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/senior_trip_bus.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/senior_trip_bus.png-wvc-sizes",
  alt: "Boarding the bus for the Senior Class Trip"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/library_study_session.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/library_study_session.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687108/img/library_study_session.png-wvc-sizes",
  alt: "Late night study session in the school library"
}];
export default function MemoryLanePhotoWall() {
  return <section data-section-id="258951" id="memory-lane-photo-wall" className="w-full py-16 md:py-24 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/parchment.png')]" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-default text-foreground tracking-tight mb-4">Memory Lane</h2>
          <p className="text-lg font-default text-muted-foreground max-w-2xl mx-auto">
            A collection of moments that defined our four years at Skyline High. Hover over the memories to see them shine.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6">
          {galleryImages.map((image, index) => <div key={index} data-index={index} className="break-inside-avoid mb-4 md:mb-6 relative group overflow-hidden rounded-md border-[4px] border-white shadow-lg transition-all duration-500 ease-in-out hover:rotate-3 hover:border-accent hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] cursor-pointer">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="w-full h-auto object-cover transition-transform duration-700 ease-in-out group-hover:scale-105 grayscale-[20%] group-hover:grayscale-0" />
              {}
              <div className="absolute inset-0 bg-secondary/0 group-hover:bg-secondary/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-all duration-500 pointer-events-none flex items-end p-4">
                <span className="text-white text-xs font-default tracking-widest uppercase bg-black/40 px-2 py-1 rounded-md">
                  Class of '05
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}